module.exports = __webpack_public_path__ + "img/greyvert.c74f0e31.png";